import {Component, h, Host, Prop} from '@stencil/core';
import { LOGO_TYPES, LOGOS, LOGO_VARIANTS, LOGO_VARIANTS_TYPES } from '../../utils/logo'

@Component({
  tag: 'snap-logo',
  styleUrl: 'snap-logo.scss',
})
export class SnapLogo {
  @Prop({ reflect: true }) product: LOGO_TYPES
  @Prop({ reflect: true }) variant: LOGO_VARIANTS_TYPES = 'stacked'
  @Prop({ reflect: true }) white: boolean = false

  componentWillLoad() {
    if (!(this.variant in LOGO_VARIANTS)) {
      this.variant = 'stacked'
    }
  }

  render() {
    return (
      <Host>
        <div class={`snap-logo ${this.white ? 'snap-logo--white' : ''}`}
             innerHTML={LOGOS[this.product + '-' + this.variant]}></div>
      </Host>
    );
  }
}
